/* eslint-disable */
const validate = {
  //必填
  validateRequired(rule, value, callback, msg) {
    var val = ("" + value).trim()
    if (val === "" || value == null) {
      callback(new Error(msg ? msg : "不能为空"))
    } else {
      callback()
    }
  },
  // 手机的验证规则
  validateMobile(rule, value, callback) {
    if (value === "") {
      callback()
      return
    }
    if (!/^1[3-9][0-9]\d{8}$/.test(value)) {
      callback(new Error("请输入正确手机号"))
      return
    }
    callback()
  },
  // 国际手机号验证规则
  validateInternationalMobile(rule, value, callback, condition) {
    let mobilePre = condition.mobilePre
    let mobile = condition.mobile
    if (mobile === "" && condition.isRequired) {
      callback(new Error("手机号不能为空"))
      return
    }

    if (mobile === "") {
      callback()
      return
    }

    if (mobilePre === "+86") {
      if (!/^1[3-9][0-9]\d{8}$/.test(mobile)) {
        callback(new Error("请输入正确手机号"))
        return
      }
      callback()
    } else {
      if (!/^\d{7,11}$/.test(mobile)) {
        callback(new Error("请输入正确手机号"))
        return
      }
      callback()
      return
    }
  },
   //TODO:delete,请使用xin-core里的方法
  // 验证密码规则
  validatePass(rule, value, callback) {
    const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/
    if (!reg.test(value)) {
      return callback(new Error("密码应为8-32位的大写字母、小写字母和数字组合"))
    } else {
      callback()
    }
  },

  // 验证码规则
  validateVerifyCode(rule, value, callback) {
    if (!/^\d{6}$/.test(value)) {
      return callback(new Error("验证码格式有误"))
    } else {
      callback()
    }
  },
  validateVerifyCode4(rule, value, callback) {
    if (!/^\d{4}$/.test(value)) {
      return callback(new Error("验证码格式有误"))
    } else {
      callback()
    }
  },
  // 电话号码
  validatePhone(rule, value, callback) {
    const reg = /^[0-9][0-9-]{5,18}[0-9]$/
    if (!reg.test(value)) {
      return callback(new Error("电话号码格式错误"))
    } else {
      callback()
    }
  },

  //邮箱
  validateEmail(rule, value, callback) {
    let val = ("" + value).trim()
    if (val === "") {
      callback()
      return
    }
    if (
      val != "" &&
      !/^[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
        val
      )
    ) {
      callback(new Error("请输入正规邮箱格式"))
      return
    }
    callback()
  },
  // 身份证号
  IdCardVerify(rule, value, callback) {
    //15位或18位身份证号(生日日期校验不做精确校验，只要是01-31即可)
    if (!/^[1-9]\d{7}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}$|^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}([0-9Xx])$/.test(value)) {
      callback(new Error("身份证号格式错误"))
    } else {
      callback()
    }
  },
  // 银行卡
  bankCardVerify(rule, value, callback) {
    if (!/^[0-9a-zA-Z\-\*]+$/.test(value) && value) {
      callback(new Error("只能输入数字、英文、*和-"))
    } else {
      callback()
    }
  },

  // 生日 0304
  birthdayVerify(rule, value, callback) {
    const month = value.substr(0, 2)
    const day = value.substr(2, 2)
    console.log(month)
    if (!/(^\d{4}$)/.test(value)) {
      callback(new Error("生日不符合规范"))
    } else if (month > 12 || month < 1) {
      callback(new Error("生日不符合规范"))
    } else if (day < 1) {
      callback(new Error("生日不符合规范"))
    } else if (month === "02" && day > 29) {
      callback(new Error("生日不符合规范"))
    } else if (
      ["01", "03", "05", "07", "08", "10", "12"].includes(month) &&
      day > 31
    ) {
      callback(new Error("生日不符合规范"))
    } else if (["04", "06", "09", "11"].includes(month) && day > 30) {
      callback(new Error("生日不符合规范"))
    } else {
      callback()
    }
  },

  //url
  linkUrlValid(rule, value, callback) {
    const reg = new RegExp(
      "^(http|https)://[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]"
    )
    if (value && !reg.test(value)) {
      return callback(new Error("必须符合http格式"))
    } else {
      return callback()
    }
  },

  //QQ
  validateQQ(rule, value, cb) {
    const reg = new RegExp("^[1-9][0-9]{4,14}$")
    if (value && !reg.test(value)) {
      return cb(new Error("QQ号格式有误"))
    } else {
      return cb()
    }
  },
  //验证是否是数字
  validateNum(rule, val, callback,condition) {
    if (val == "" || val == undefined) {
      callback()
    }
    if (isNaN(val)) {
      if(condition.message){
        callback(new Error(condition.message));
      }else{
        callback(new Error("请输入数字"))
      }
    } else {
      callback()
    }
  },
  // 验证是否是数字（严格校验）
  validateStrictNum(rule, val, callback,condition) {
    const reg = new RegExp("^[1-9]{1}[0-9]*$");
    if (val === "0" || val == "" || val == undefined) {
      callback()
      return
    }
    if (!reg.test(val)) {
      if(condition.message){
        callback(new Error(condition.message));
      }else{
        callback(new Error("请输入数字"))
      }
    } else {
      callback()
    }
  },

  // 数值范围大小
  validateValueRange(rule, value, callback, condition) {
    //考虑到非必填的情况
    if (value === "" || value == null) {
      callback()
      return
    }
    const min = condition.min
    const max = condition.max
    if (value < min || value > max) {
      if (condition.message) {
        callback(
          new Error(
            condition.message
          )
        )
      } else {
        callback(new Error("数字范围在" + min + "~" + max + "之间"))
      }
    } else {
      callback()
    }
  },

  //自定义小数位数
  validateNumberBits(rule, value, callback, condition) {
    //考虑到非必填的情况
    if (value === "" || value == null) {
      callback()
      return
    }
    const bit = condition.bit;
    const re = `^-?[0-9]+(\.?[0-9]{0,${bit}})?$`
    const reg = new RegExp(re)
    if (!reg.test(value)) {
      callback(new Error(`最多输入${bit}位小数`))
    } else {
      callback()
    }
  },
  validateOneFloat(rule, value, callback) {
    return validate.validateNumberBits(rule, value, callback, {bit: 1})
  },
  //两位小数
  validateTwoFloat(rule, value, callback) {
    return validate.validateNumberBits(rule, value, callback, {bit: 2})
  },
  //三位小数
  validateThreeFloat2(rule, value, callback) {
    return validate.validateNumberBits(rule, value, callback, {bit: 3})
  },
  //4位小数
  validateFourFloat(rule, value, callback) {
    return validate.validateNumberBits(rule, value, callback, {bit: 4})
  },
  //4位小数
  validateFiveFloat(rule, value, callback) {
    return validate.validateNumberBits(rule, value, callback, {bit: 5})
  },


  //整数 （包括正整数，负整数，0）
  validateInteger(rule, value, callback,condition) {
    if (value === "" || value == null) {
      callback()
      return
    }
    if (!/^(0|[0-9][0-9]*|-[0-9][0-9]*)$/.test(value)) {
      if(condition.message){
        callback(new Error(condition.message));
      }else{
        callback(new Error("只能输入整数"))
      }
    } else {
      callback()
    }
  },

  // 正整数
  verifyPositiveNumber(rule, value, callback) {
    if (value === "" || value == null) {
      callback()
      return
    }
    if (!/^[1-9]\d*$/.test(value)) {
      callback(new Error("请输入正整数"))
    } else {
      callback()
    }
  },
  // 自然数
  validateNaturalIntegers(rule, val, callback) {
    if (val === "" || val == null) {
      callback()
      return
    }
    if (!/^\d*$/.test(val)) {
      callback(new Error("请输入自然数"))
    } else {
      callback()
    }
  },
  //不能为0
  noEqualZero(rule, val, cb) {
    if (val === "") {
      cb()
    } else if (+val === 0) {
      cb(new Error("不能为0"))
    } else {
      cb()
    }
  },

  // 判断0.5的倍数
  verifyDotFiveFloat(rule, val, cb) {
    if (val % 0.5 !== 0) {
      cb("请输入0.5的倍数")
      return
    } else {
      cb()
      return
    }
  },
  // 判断0.25的倍数
  verifyDotTwoFiveFloat(rule, val, cb) {
    if (val % 0.25 !== 0) {
      cb("请输入0.25的倍数")
      return
    } else {
      cb()
      return
    }
  },

  //mac 地址
  verifyMac(rule, val, cb) {
    let reg = /^[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}:[A-Fa-f\d]{2}$/
    if (!reg.test(val)) {
      cb(new Error("请输入正确的MAC地址"))
    } else {
      cb()
    }
  },

  //审批导出文件名
  verifySpecialChar(rule, val, cb){
    let reg = /[?*:"<>\\/|]/im
    if (reg.test(val)) {
      cb(new Error('名称不能包含特殊字符（?*:"<>\\/|）'))
    } else {
      cb()
    }
  }
}
export default validate
